import React, { useState } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import dayjs from "dayjs";

import { customStyles } from "../../../../Bookclosure/Components/AddTaskModal";
import InputGroup from "../../../elements/InputGroup";

import { ReactComponent as CloseGreyIcon } from "../../../assets/icons/close_grey.svg";
import CustomDropdownIndicator from "../../../elements/CustomDropdownIndicator";

const animatedComponents = makeAnimated();

const FilterRow = ({ onChange, onRemove, filterAttr = [] }) => {
  const filterOptions = filterAttr.map((f) => ({
    label: f.name,
    value: f.key,
  }));

  const [selectedField, setSelectedField] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [selectedInputType, setSelectedInputType] = useState(null);

  const handleFieldChange = (selectedOption) => {
    const filterDef = filterAttr.find((f) => f.key === selectedOption.value);
    setSelectedField(filterDef);
    setSelectedType(null);
    setInputValue("");
    setSelectedInputType(filterDef.type);
    if (filterDef) {
      onChange({
        field: filterDef.key,
        dataType: filterDef.type,
        // fieldType: filterDef.fieldType,
        filterType: null,
        value: "",
      });
    }
  };

  const handleTypeChange = (selectedOption) => {
    setSelectedType(selectedOption.value);
    if (selectedField) {
      onChange((prev) => ({
        ...prev,
        filterType: selectedOption.value,
      }));
    }
  };

  const handleInputChange = (value) => {
  
  
  if (selectedField?.type === "number") {
    if (!/^\d*$/.test(value)) return; 
  }

  setInputValue(value);

  if (selectedField && selectedType) {
    onChange((prev) => ({
      ...prev,
      value: value
    }));
  }
};


  const filterTypeOptions = selectedField
    ? selectedField.filterTypes.map((type) => ({
        label: type,
        value: type,
      }))
    : [];

  return (
    <>
      <Select
        placeholder="Identifier"
        value={
          selectedField
            ? { label: selectedField.name, value: selectedField.key }
            : null
        }
        onChange={handleFieldChange}
        options={filterOptions}
        className="w-100 mt-0"
        classNamePrefix="select"
        components={{
          ...animatedComponents,
          IndicatorSeparator: () => null,
          DropdownIndicator: CustomDropdownIndicator,
        }}
        styles={customStyles}
        menuPosition="static"
        menuPlacement="bottom"
      />

      <Select
        placeholder="Relative"
        value={
          selectedType ? { label: selectedType, value: selectedType } : null
        }
        onChange={handleTypeChange}
        options={filterTypeOptions}
        isDisabled={!selectedField}
        className="w-100 mt-0"
        classNamePrefix="select"
        components={{
          ...animatedComponents,
          IndicatorSeparator: () => null,
          DropdownIndicator: CustomDropdownIndicator,
        }}
        styles={customStyles}
        menuPosition="static"
        menuPlacement="bottom"
      />

      {/* {(!selectedInputType || selectedInputType !== "date") && ( */}
      <InputGroup
        inputs={[
          <input
            type={selectedInputType === "date" ? "date" : "text"}
            disabled={!selectedType || selectedType === "is empty"}
            value={inputValue}
            onChange={(e) =>
              handleInputChange(
                selectedInputType === "date"
                  ? dayjs(e.target.value).format("DD-MM-YYYY")
                  : e.target.value
              )
            }
          />,
        ]}
      />
      {/* // )} */}
      {/* {selectedInputType === "date" && (
        <InputGroup
          inputs={[
            <input
              key="filter-input"
              type="date"
              disabled={!selectedType}
              value={inputValue}
              onChange={handleInputChange}
            />,
          ]}
        />
      )} */}
      <button
        onClick={onRemove}
        style={{
          background: "transparent",
          border: "none",
          fontSize: "1.2rem",
          cursor: "pointer",
          alignSelf: "baseline",
        }}
        title="Remove filter"
      >
        <CloseGreyIcon />
      </button>
    </>
  );
};

export default FilterRow;
